mutation SubmitReview(
    $video_id: ID!
    $answers: [Boolean]!
) {
    submitReview(
        video_id: $video_id
        answers: $answers
    ) {
        status
        message
    }
}
